export const formatTimeRange = (startTime, endTime) => `${startTime} - ${endTime}`;

// v2 timings: an end at or before the start ends the next calendar day (plan 01-schema §3.1).
export const isOvernightRange = (startTime, endTime) => endTime <= startTime;
